// Shared plumbing for per-category notification preference screens
// (peptide + DME). Each product line makes its own store with its own
// cache key and updated-event name; the sessionStorage/CustomEvent
// mechanics live here exactly once.

export const CHANNEL_OPTIONS = [
  { value: "both", label: "Email + in-app" },
  { value: "email", label: "Email only" },
  { value: "in_app", label: "In-app only" },
  { value: "none", label: "Off" },
];

// emailLocked categories are duty-critical: the backend refuses email-less
// channels for them, so the UI only offers options that include email.
export function channelOptionsFor(emailLocked) {
  return emailLocked ? CHANNEL_OPTIONS.filter((o) => o.value === "both" || o.value === "email") : CHANNEL_OPTIONS;
}

export function channelAllowsInApp(channel) {
  // Absent pref = default "both".
  return channel == null || channel === "both" || channel === "in_app";
}

// Switch-matrix helpers (UI refresh 2026-08-07). The backend keeps storing a
// single channel string per category; the UI renders it as two independent
// Email / In-app switches, so these two functions are the only place the
// mapping lives.
export function flagsFromChannel(channel) {
  const ch = channel == null ? "both" : channel;
  return {
    email: ch === "both" || ch === "email",
    inApp: ch === "both" || ch === "in_app",
  };
}

export function channelFromFlags(email, inApp) {
  if (email && inApp) return "both";
  if (email) return "email";
  if (inApp) return "in_app";
  return "none";
}

export function makePrefsStore({ cacheKey, updatedEvent }) {
  return {
    readCachedPrefs() {
      try {
        return JSON.parse(sessionStorage.getItem(cacheKey)) || {};
      } catch {
        return {};
      }
    },
    writeCachedPrefs(map) {
      try {
        sessionStorage.setItem(cacheKey, JSON.stringify(map || {}));
      } catch {
        /* ignore */
      }
    },
    notifyUpdated(map) {
      window.dispatchEvent(new CustomEvent(updatedEvent, { detail: map }));
    },
  };
}
